import React, { forwardRef } from 'react'

import { IconProps } from './types'

const Key = forwardRef<SVGSVGElement, IconProps>(
  ({ color, size, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.25 9.5C12.3211 9.5 14 7.82107 14 5.75C14 3.67893 12.3211 2 10.25 2C8.17893 2 6.5 3.67893 6.5 5.75C6.5 6.00685 6.52582 6.25767 6.57501 6.5L2.5 10.5V13.5H5L6 12.5V11H7.5L9 9.28662C9.39097 9.42481 9.81171 9.5 10.25 9.5Z"
        stroke={color || 'currentColor'}
      />
      <path
        d="M11.5 5.75C11.5 6.44036 10.9404 7 10.25 7C9.55964 7 9 6.44036 9 5.75C9 5.05964 9.55964 4.5 10.25 4.5C10.9404 4.5 11.5 5.05964 11.5 5.75Z"
        stroke={color || 'currentColor'}
      />
    </svg>
  ),
)
Key.displayName = 'Key'

export default Key
